export const pageSize = import.meta.env.VITE_PAGINATION_SIZE || 15;
